import styled from '@emotion/styled';
import * as React from 'react';
import { MarketsSmall } from '../../shared/MarketsComponents';

const Container = styled.div`
  padding-top: 10px;
`;

interface IProps {
  text?: string;
}

export function MarketsDisclaimer({ text }: IProps) {
  return (
    <Container>
      <MarketsSmall>{text}</MarketsSmall>
    </Container>
  );
}
